/**
* DevExpress Dashboard (_geo-point-map-data-controller.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { deepExtend } from '../_jquery-helpers';
import { geoPointMapDataControllerBase } from './_geo-point-map-data-controller-base';
export class geoPointMapDataController extends geoPointMapDataControllerBase {
    constructor(options) {
        super(options);
    }
    getPoint(index) {
        return deepExtend(super.getPoint(index), {
            text: this._getMeasureDisplayText(index, this.viewModel.ValueId)
        });
    }
}
